"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSender = exports.STATUS_PRIORITIES = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("./logger");
exports.STATUS_PRIORITIES = (_a = {},
    _a[logger_1.StatusType.debug] = 0,
    _a[logger_1.StatusType.info] = 1,
    _a[logger_1.StatusType.warn] = 2,
    _a[logger_1.StatusType.error] = 3,
    _a);
function createSender(sendToHttpImpl, handlerType, level, loggerContext) {
    if (handlerType === void 0) { handlerType = logger_1.HandlerType.http; }
    if (level === void 0) { level = logger_1.StatusType.debug; }
    if (loggerContext === void 0) { loggerContext = {}; }
    var conf = {
        level: level,
        handlerType: handlerType,
    };
    var contextManager = (0, browser_core_1.createContextManager)();
    contextManager.set(loggerContext);
    function isAuthorized(status, handlerType) {
        var sanitizedHandlerType = Array.isArray(conf.handlerType) ? conf.handlerType : [conf.handlerType];
        return exports.STATUS_PRIORITIES[status] >= exports.STATUS_PRIORITIES[conf.level] && (0, browser_core_1.includes)(sanitizedHandlerType, handlerType);
    }
    function sendToHttp(message, messageContext, status) {
        if (isAuthorized(status, logger_1.HandlerType.http)) {
            sendToHttpImpl((0, browser_core_1.combine)({ message: message, status: status }, contextManager.get(), messageContext));
        }
    }
    function sendToConsole(message, messageContext, status) {
        if (isAuthorized(status, logger_1.HandlerType.console)) {
            browser_core_1.display.log("".concat(status, ": ").concat(message), (0, browser_core_1.combine)(contextManager.get(), messageContext));
        }
    }
    return {
        getContextManager: function () {
            return contextManager;
        },
        setLevel: function (level) {
            conf.level = level;
        },
        setHandler: function (handlerType) {
            conf.handlerType = handlerType;
        },
        sendToHttp: sendToHttp,
        sendLog: function (message, messageContext, status) {
            if (status === void 0) { status = logger_1.StatusType.info; }
            sendToHttp(message, messageContext, status);
            sendToConsole(message, messageContext, status);
        },
    };
}
exports.createSender = createSender;
//# sourceMappingURL=sender.js.map